<template>
    <v-container>
        <div v-if="!isAdmin && !isBusy"> You dont have permission to view this page</div>
        <div v-if="isAdmin">
            <div class="d-flex justify-space-between mt-10 mb-5">
                <h2 class="mb-3">Report Columns</h2>
            </div>

            <v-select :items="reportTables"
                      item-text="name"
                      item-value="id"
                      v-model="selectedReportTable"
                      label="Report Tables"></v-select>

            <div class="d-flex justify-space-between mt-10 mb-5" v-if="selectedReportTable">
                <v-btn class="mr-2 mt-1"
                       @click="onOpenCreateModal"
                       color="secondary">
                    <v-icon class="mr-1">mdi-plus</v-icon> Create Report Column
                </v-btn>
            </div>

            <v-data-table v-if="selectedReportTable"
                          :headers="headers"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :items="reportTableColumns"
                          must-sort
                          item-key="key"
                          :server-items-length="reportTableTotalItems"
                          :loading="isBusy"
                          :items-per-page.sync="reportTableColumnPageSize"
                          :page.sync="reportTableColumnPageNo"
                          class="elevation-1">


                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon v-bind="attrs"
                                   @click="onOpenEditModal(item.id)"
                                   v-on="on" color="lighten-2">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>Update Report Column</span>
                    </v-tooltip>

                </template>

                <template v-slot:item.canFilter="{ item }">
                    {{ item.canFilter | YesNo }}
                </template>
            </v-data-table>
        </div>


        <sweet-modal :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" ref="createUpdateReportTableColumnModal" blocking>
            <v-form v-model="isValid" ref="reportTableForm">
                <v-container>
                    <h3 class="mb-3">
                        {{actionType}} Report Column
                    </h3>
                    <v-row>
                        <v-col cols="12" v-if="actionType === 'Create'">
                            <v-select :items="tableColumns"
                                      v-model="selectedTableColumn"
                                      label="Select Column"></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="reportTableColumn.friendlyName"
                                          :rules="friendlyNameRules"
                                          :counter="250"
                                          label="Friendly Name"
                                          required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" align="right">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        <v-checkbox v-model="reportTableColumn.canFilter"
                                                    label="Can Filter"></v-checkbox>
                                    </div>
                                </template>
                                <span>Used for the chart builder to determine if the column can be used to filter a chart. For example Severity Type could be used to filter on Sev A Sev B etc.</span>
                            </v-tooltip>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" align="right" v-if="actionType === 'Create'">
                            <v-btn depressed
                                   @click="createReportTableColumn"
                                   :disabled="!isValid"
                                   align="right"
                                   class="mt-10 font-bold"
                                   color="primary">
                                Create
                            </v-btn>
                        </v-col>
                        <v-col cols="12" align="right" v-if="actionType === 'Edit'">
                            <v-btn depressed
                                   @click="editReportTableColumn"
                                   :disabled="!isValid"
                                   align="right"
                                   class="mt-10 font-bold"
                                   color="primary">
                                Save
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-container>
            </v-form>
        </sweet-modal>
    </v-container>
</template>

<script>
    import ReportTableService from "../../services/reportTableService"
    import config from '../../../public/okta.config.json';
    export default {
        name: 'ChartColumns',
        data: function () {
            return {
                isAdmin: false,
                isBusy: true,
                accessToken: "",
                reportTables: [],
                selectedReportTable: null,
                headers: [
                    {
                        text: 'Friendly Name',
                        align: 'start',
                        sortable: true,
                        value: 'friendlyName',
                    },
                    {
                        text: 'Column Name',
                        align: 'start',
                        sortable: true,
                        value: 'columnName',
                    },
                    {
                        text: 'Can Filter',
                        align: 'start',
                        sortable: true,
                        value: 'canFilter',
                    },
                    { text: '', value: 'actions', align: 'end', sortable: false },
                ],
                //report table columns
                reportTableColumns: [],
                reportTableColumnSearchText: "",
                reportTableColumnPageNo: 1,
                reportTableColumnPageSize: 10,
                reportTableTotalItems: 0,
                reportTableColumn: {
                    columnName: "",
                    friendlyName: "",
                    canFilter: false
                },
                sortBy: 'friendlyName',
                sortDesc: false,
                searchTimer: null,
                friendlyNameRules: [
                    v => !!v || 'Friendly Name is required',
                    v => v?.length <= 250 || 'Friendly Name  must be less than 250 characters'
                ],
                tableColumns: [],
                selectedTableColumn: null,
                isValid: false,
                actionType: "Create"
            }
        },
        components: {

        },
        watch: {
            deep: true,
            immediate: true,
            selectedReportTable() {
                this.searchReportTableColumns();
            },
            reportTableColumnPageNo: function () {
                this.searchReportTableColumns();
            },
            reportTableColumnPageSize: function () {
                this.searchReportTableColumns();
            },
            sortBy: function () {
                this.searchReportTableColumns();
            },
            sortDesc: function () {
                this.searchReportTableColumns();
            },
            reportTableColumnSearchText: function () {
                let self = this;
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(function () {
                    self.searchReportTableColumns();
                }, 1000);
            }
        },
        computed: {

        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                var user = await this.$auth.getUser();
                this.isAdmin = user.groups.includes(config.adminGroup);

                if (this.isAdmin) {
                    await this.getReportTables();
                }
            },
            async getReportTables() {
                this.isBusy = true;
                this.reportTables = await ReportTableService.getReportTables(this.accessToken);
                this.isBusy = false;
            },
            async searchReportTableColumns() {
                if (this.selectedReportTable) {
                    this.isBusy = true;

                    var sortBy = this.sortBy ? "friendlyName" : this.sortBy;
                    var sortDesc = this.sortDesc === false ? "ASCENDING" : "DESCENDING"

                    let result = await ReportTableService.searchReportTableColumns(
                        this.selectedReportTable,
                        this.reportTableColumnSearchText,
                        this.reportTableColumnPageNo,
                        this.reportTableColumnPageSize,
                        sortBy,
                        sortDesc,
                        this.accessToken);

                    this.reportTableColumns = result.data.map((item, key) => ({ ...item, key }));
                    this.reportTableTotalItems = result.count;

                    this.isBusy = false;
                }
            },
            async onOpenCreateModal() {

                if (this.selectedReportTable) {
                    this.actionType = "Create";
                    this.tableColumns = await ReportTableService.getReportTableDefinitions(this.selectedReportTable, this.accessToken);

                    this.selectedTableColumn = null;
                    this.reportTableColumn = {
                        columnName: "",
                        friendlyName: "",
                        canFilter: false
                    };

                    this.$refs.reportTableForm.resetValidation();
                    this.$refs.createUpdateReportTableColumnModal.open();
                }
            },

            async onOpenEditModal(reportTableColumnId) {

                if (this.selectedReportTable) {
                    this.actionType = "Edit";
                    var result = await ReportTableService.getReportTableColumnById(reportTableColumnId, this.accessToken);

                    this.reportTableColumn = result;

                    this.$refs.reportTableForm.resetValidation();
                    this.$refs.createUpdateReportTableColumnModal.open();
                }
            },
            async createReportTableColumn() {
                if (this.selectedReportTable && this.isValid) {

                    this.reportTableColumn.columnName = this.selectedTableColumn;
                    var result = await ReportTableService.createReportTableColumn(
                        this.selectedReportTable,
                        this.reportTableColumn,
                        this.accessToken);


                    if (result) {
                        await this.searchReportTableColumns();
                        this.$refs.createUpdateReportTableColumnModal.close();
                    }
                }
            },
            async editReportTableColumn() {
                let result = await ReportTableService.updateReportTableColumn(this.reportTableColumn.id, this.reportTableColumn, this.accessToken);

                if (result) {
                    await this.searchReportTableColumns();
                    this.$refs.createUpdateReportTableColumnModal.close();
                }
            }
        },
        created() {
            this.setup();
        },
        mounted() {

        },
    }
</script>
